import { useState } from 'react';
import { useAuth } from '../../auth/AuthContext';
import type { Site } from '../../domain/inventory';
import { formatSiteAddress } from '../../domain/siteContact';
import { siteLabel } from '../../lib/site-label';
import { EditSiteContactDrawer } from './EditSiteContactDrawer';

/**
 * Shows a site's shipping address with an entry point to edit it. The people
 * to ship to are the site's contacts (tidaltech/koi#8359).
 */
export function SiteContactSummary({ site }: { site: Site }) {
  const { canMutate } = useAuth();
  const [editing, setEditing] = useState(false);
  const address = formatSiteAddress(site.address);

  return (
    <section className="site-contact" aria-label={`Address for ${siteLabel(site)}`}>
      <div className="site-contact-heading">
        <strong>Address</strong>
        <button
          type="button"
          className="link-button"
          onClick={() => setEditing(true)}
          disabled={!canMutate}
          title={canMutate ? undefined : 'Sign in to edit the site address'}
        >
          {address ? 'Edit' : 'Add'}
          <span className="visually-hidden"> address for {siteLabel(site)}</span>
        </button>
      </div>
      {address ? <p>{address}</p> : <p className="empty-note">No address recorded.</p>}
      {editing ? <EditSiteContactDrawer site={site} onClose={() => setEditing(false)} /> : null}
    </section>
  );
}
